
import {cssFiltersForCanvas} from 
    "./../../../variables/cssFiltersForCanvas.js";



import {changeIfEmpty} from
   "./../../change/changeIfEmpty.js";

import {SmetioRangeSlider} from
   "./../../../classes/smetioRangeSlider/SmetioRangeSlider.js";

export function getRangeSlidersForCanvasFilters(obj={}){

	/**** 
	 * 
	 *  THIS FUNCTION RECEIVES THE cssFiltersForCanvas AND THEN CREATES A SLIDER FOR EACH OF THE FILTERS
	 * IF THE cssFiltersForCanvas IS NOT PASSED TO IT, THE FUNCTION WILL USE THE DEFAULT VALUES OF
	 * THE cssFiltersForCanvas AS STORED IN THE cssFiltersForCanvas.js FILE
	 * 
	 * THE cssFiltersForCanvas CAN BE ALTERED BY OTHER FILES BEFORE IT IS PASSED TO THIS FUNCTION
	 * 		FOR EXAMPLE THE FUNCTION THAT WILL BE CALLED WHEN EACH FILTER VALUE IS CHANGED 
	 * 		NEEDS TO BE SET BEFORE THE cssFiltersForCanvas IS PASSED TO THIS FUNCTION
	 * 
	 * 		ONE CAN ALSO REMOVE SOME FILTER BY CHANGING THEIR isNeeded VALUE TO false
	 * 
	 * ****/

	let myCssFiltersForCanvas = changeIfEmpty(obj.filtersObj, cssFiltersForCanvas); 

	const storageObj = obj.storageObj;

	let output = "";

	/**** GET ALL THE FILTERS OPTIONS FROM THE CSS PROPERTIES ****/

	$.each(myCssFiltersForCanvas, (key, value)=>{

		if(!value.isNeeded){

			return true;

		};

		const smetioRangeSlider = new SmetioRangeSlider();
		smetioRangeSlider.sliderText = value.text;
		smetioRangeSlider.min = value.minValue;
		smetioRangeSlider.max = value.maxValue;
		smetioRangeSlider.defaultValue = value.defaultValue;
		smetioRangeSlider.unit = value.unit;
		smetioRangeSlider.property = value.property;
		smetioRangeSlider.onChangeFunc = value.onChangeFunc;
		smetioRangeSlider.storageObj = storageObj;

		output += smetioRangeSlider.render();

	});

	return output;

};